import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { CrossSaleRequestHelper } from "../../../Lib/Helper/AxProdSelection/CrossSaleRequestHelper";
import { PriceCalculationHelper } from "../../../Lib/Helper/AxProdSelection/PriceCalculationHelper";
import { ProductMapper } from "../../../Lib/Mapper/ProductMapper";
import { AxLimeStone } from "../../../Limestone/AxLimeStone";
import { IAddToCartRequest } from "../../../Models/Tickets/IAddToCartRequest";
import { AxProdNonPredateableInit, NonPreDateable } from "../Abstraction/NonPreDateable";

@ModuleName("AxProdNonPredateable")
export class AxProdNonPredateable extends NonPreDateable implements AxInit {
    public ProjNr: number;
    public PoolNr: number;
    public TicketTypeNr: number;
    private containerSelector = ".prod_selection__prod-list";
    private totalPriceSelector = ".prod_selection__calculated-sum";
    private serviceVoucherCoverage = {};

    constructor(private _ProductMapper = new ProductMapper(),
            private _AxLimestone = new AxLimeStone()) { super(); }

    AxInit(initData: AxProdNonPredateableInit): void {
        this.ProjNr = initData.ProjNr;
        this.PoolNr = initData.ProductGroupIdentifier;
        this.TicketTypeNr = initData.Id;

        // Initialize service voucher coverage if available
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("serviceVoucher") === "true") {
            const personTypeIds = urlParams.getAll("personTypeId");

            personTypeIds.forEach(id => {
                if (this.serviceVoucherCoverage[id]) {
                    this.serviceVoucherCoverage[id]++;
                } else {
                    this.serviceVoucherCoverage[id] = 1;
                }
            });

            PriceCalculationHelper.initServiceVoucherCoverage(this.serviceVoucherCoverage);

            // Bind quantity change events to recalculate the total price
            PriceCalculationHelper.bindQuantityChangeEvents(this.containerSelector, this.totalPriceSelector);
        }

        $('.prod_selection__persontype-submit').on('click', e => {
            this._AxLimestone.LockButton(e.delegateTarget);
            this.ToSummary();
        });

        this.Init(initData);
    }

    ToSummary(): void {
        if (this._TicketList.ProductList.filter(x => x.Quantity > 0).length > 0) {
            const urlParams = new URLSearchParams(window.location.search);
            let requestObj: IAddToCartRequest = {
                Date: moment().format('YYYY-MM-DD'),
                ProjNr: this.ProjNr,
                PoolNr: this.PoolNr,
                TicketTypeId: this.TicketTypeNr,
                PersonTypes: this._ProductMapper.GetPersonTypeList(this._TicketList.ProductList),
                Barcode: urlParams.get('barcode'),
            };
            CrossSaleRequestHelper.addToRequest(requestObj);

            // Add service voucher information to the request URL
            let postUrl = this.PostURL;
            if (Object.keys(this.serviceVoucherCoverage).length > 0) {
                if (postUrl.indexOf('?') === -1) {
                    postUrl += '?serviceVoucher=true';
                } else {
                    postUrl += '&serviceVoucher=true';
                }

                // Add each person type ID with coverage to the URL
                Object.keys(this.serviceVoucherCoverage).forEach(personTypeId => {
                    for (let i = 0; i < this.serviceVoucherCoverage[personTypeId]; i++) {
                        postUrl += `&personTypeId=${personTypeId}`;
                    }
                });
            }

            this._summaryRedirect.redirect(postUrl, requestObj, false);
        }
    }
}
